var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intersector"},[(_vm.hasMoreData)?_c('mds-loader',{staticClass:"intersector__status--loading",attrs:{"size":"small"}}):_c('span',{staticClass:"intersector__status--empty",domProps:{"textContent":_vm._s('No more data available')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }